// extracted by mini-css-extract-plugin
module.exports =  {"collapsible-group":"y8nWeVV","collapsibleGroup":"y8nWeVV","collapsible":"PMpNgwt"};